import { AxiosResponse } from 'axios';
import api from './api';

export default {
  mistreatmentByUid(uid: string): Promise<AxiosResponse> {
    return api.get(`/mistreatments/mistreatment-by-uid/${uid}`);
  },
};
